import { ReducersTypes } from "../constants/ReducersTypes";

export const user = (
  state = {
    clients: [],
    userSettings: {},
    corporateEntities: [],
    isFetchingAccessibleClients: false,
  },
  action
) => {
  switch (action.type) {
    case ReducersTypes.USER:
      return { ...state, ...action.payload };
    case ReducersTypes.USER_CLIENTS:
      return { ...state, ...action.payload };
    case ReducersTypes.USER_SETTINGS:
      return { ...state, ...action.payload };
    case ReducersTypes.USER_CORPORATE_ENTITIES:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default user;
